import React from 'react';
import styled from 'styled-components';

interface DataParam {
	minHeight?: string;
	width?: string;
}

interface PropParam {
	width?: string;
}
export const Progress = styled.div`
	width: 25%;
	background-color: #ffffff;
	border-style: solid;
	border-color: #1b73bd;
`;
export const Bar = styled.div<{ $width?: string }>`
	width: ${(props) => props.$width};
	height: 30px;
	background-color: #1b73bd;
	text-align: center;
	line-height: 30px;
	color: white;
`;
export const LoaderLayout = styled.div<DataParam>`
	justify-content: center;
	width: 100%;

	min-height: ${({ minHeight }) => (minHeight !== '' ? minHeight : '50%')};
`;

export const StyledLoaderBar = (props: PropParam) => {
	const minHeight = '';
	const { width } = props;
	const percentageWidth = `${width}%`;
	return (
		<>
			<LoaderLayout
				minHeight={minHeight}
				style={{
					alignItems: 'center',
					display: 'flex',
					flexDirection: 'column',
					marginBottom: '-10%',
				}}
			>
				{/* <Spinner /> */}
				{width === '100' ? `Loading supplemental information` : `${percentageWidth} Complete`}
				<Progress>
					<Bar $width={percentageWidth} />
				</Progress>
			</LoaderLayout>
		</>
	);
};

export default StyledLoaderBar;
